import { PopUpCalendly } from './PopUpCalendly';

export type { TypePopUpCalendlyProps } from './types';
export default PopUpCalendly;
